import React from "react";

const ProductShowcase1 = () => {
  return (
    <div className="row bg-white rounded-4 shadow overflow-hidden w-100 mt-3">
      {/* Left Image Section */}
      <div className="col-md-6 order-first d-flex justify-content-center align-items-center py-4">
        <div
          className="rounded-4 overflow-hidden"
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "300px",
            padding: "10px 0",
          }}
        >
          <img
            src="papertube.jpeg" // Replace with actual image
            alt="Product"
            className="w-100 h-100 object-fit-cover"
            style={{ borderRadius: "16px" }}
          />
        </div>
      </div>

      {/* Right Content Section */}
      <div className="col-md-6 p-3 d-flex flex-column justify-content-center">
        <h2 className="fw-bold text-black">Paper Tube</h2>
        <p className="text-muted">
          Paper tubes are strong, lightweight, and eco-friendly packaging
          solutions used in various industries.
        </p>

        <ul className="text-muted">
          <li className="text-danger fw-semibold">
            Eco-friendly & biodegradable
          </li>
          <li className="text-danger fw-semibold">
            Highly durable & customizable
          </li>
          <li className="text-danger fw-semibold">
            Ideal for packaging & industrial use
          </li>
        </ul>

        <a
          href="#contactus"
          className="btn btn-danger mt-3 px-4 py-2 fw-semibold shadow-sm"
        >
          Contact
        </a>
      </div>
    </div>
  );
};

export default ProductShowcase1;
